"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsContext = void 0;
const react_1 = require("react");
exports.SettingsContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=context.js.map